export default "__VITE_ASSET__Cf6Tpc$L__"